import React from "react";

import { render } from "app/bootstrap";

import LegacyPage from "./LegacyPage";

// ECCLOUD-11038 phase 5: the site dashboard (a legacy page) mounts the planner's Installed view into its Status Map
// widget through this entry; the planner chunk is loaded only when a widget asks for it
window.fe2.loadInstalledMap = () => import("fragments/coverage-planner/embed").then(module => module.mountInstalledMap);

render(<LegacyPage />);
